export default function () {
  this.loadCategories()
}
